module.exports = __webpack_public_path__ + "static/media/30th_march.d63873e0.jpeg";